import { StyledEngineProvider } from '@mui/material';
import { ReactNode } from 'react';
import { Themed } from './Themed';

export const AppProvider = ({ children }: { children: ReactNode }) => (
  <StyledEngineProvider injectFirst>
    <Themed>{children}</Themed>
  </StyledEngineProvider>
);
